import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import Login from "@/pages/Login";
import Admin from "@/pages/Admin";
import TVDisplay from "@/pages/TVDisplay";

function Protected({ children }) {
  const { user, ready } = useAuth();
  if (!ready) return <div className="min-h-screen flex items-center justify-center text-muted-foreground">Caricamento…</div>;
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

function App() {
  useEffect(() => {
    const TITLE = "I.T.E. A. Gallo - Gestione sostituzioni";
    document.title = TITLE;
    const obs = new MutationObserver(() => {
      if (document.title !== TITLE) document.title = TITLE;
    });
    const titleEl = document.querySelector("title");
    if (titleEl) obs.observe(titleEl, { childList: true });
    return () => obs.disconnect();
  }, []);
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/tv" element={<TVDisplay />} />
            <Route path="/admin" element={<Protected><Admin /></Protected>} />
            <Route path="/" element={<Navigate to="/admin" replace />} />
            <Route path="*" element={<Navigate to="/admin" replace />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-right" richColors />
      </AuthProvider>
    </div>
  );
}

export default App;
